import React from "react";
import { Card, Col, Row, Button } from "react-bootstrap";
import { AwardFill, CheckCircleFill, PhoneFill, Shop, GeoAltFill, Hammer } from "react-bootstrap-icons";
import buildingImage from "../../utils/punto-fisico.webp";
import { useCompanyInfo } from "../../hooks/useCompanyInfo";
import NavbarUni from "./componentes/headUni";
import Marquee from "./componentes/marquee";
import FooterPublic from "./FooterPublic";
import PreguntasFrecuentes from "./Questions";
import WhatsAppButton from "./componentes/WhatsAppButton";

const AboutUs = () => {
    const { companyData } = useCompanyInfo();

    const storeAddress = `${companyData.direccion} ${companyData.ciudad} - ${companyData.departamento}`;
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(storeAddress)}`;
    return (
        <>
            <Marquee />
            <NavbarUni />
            <div className="p-5 color-bg-secundary">
                <Row className="align-items-center">
                    {/* Texto a la izquierda */}
                    <Col lg={6} className="mb-4 mb-lg-0">
                        <h2 className="text-uppercase color-primary mb-3 fs-6">Acerca de Nosotros</h2>
                        <h3 className="fw-bold color-primary fs-1 mb-4">Somos emprendedores en Colombia</h3>
                        <p className="text-muted fs-5 lh-lg">
                            Somos una tienda líder en la distribuciona al por mayor ya al detal de bolsos de alta calidad en Colombia.
                            Nos encargamos de que cada pieza sea con materiales premium y acabados impecables,
                            garantizando durabilidad, comodidad y estilo en cada producto.
                        </p>
                        <p className="text-muted fs-5 lh-lg">
                            Desde hace años, vestimos a miles de clientes con bolsos que combinan tendencia,
                            calidad y precio competitivo.
                        </p>
                    </Col>

                    {/* Imagen de edificio a la derecha */}
                    <Col lg={6}>
                        <div className="position-relative">
                            <img
                                src={buildingImage}
                                alt="Nuestro local"
                                className="w-100 rounded-4 shadow-lg"
                                style={{ objectFit: 'cover', maxHeight: '400px' }}
                            />
                            <div className="position-absolute bottom-0 start-0 w-100 p-4" style={{ background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.89))', borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}>
                                <div className="d-flex align-items-center text-white mb-2">
                                    <Shop size={32} className="text-light me-3" />
                                    <div>
                                        <h5 className="mb-0 fw-bold">Tienda Física</h5>
                                        <small className="text-white">{storeAddress}</small>
                                    </div>
                                </div>
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="d-flex align-items-center"
                                    href={googleMapsUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <GeoAltFill className="me-2 color-primary" />
                                    Cómo llegar
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Sección de beneficios */}
            <div className="p-5 color-bg-secundary">
                <h4 className="text-center fw-bold fs-2 color-primary mb-2 mb-md-5">¿Por qué comprar con nosotros?</h4>
                <Row>
                    {/* Tarjeta 1 - Importadores */}
                    <Col md={3} className="mb-4">
                        <Card className="color-bg-secundary h-100 p-4 border-0 shadow-sm">
                            <Card.Body className="text-center">
                                <div className="mb-3">
                                    <Hammer size={48} className="color-primary" />
                                </div>
                                <Card.Title className="fw-bold mb-3" style={{color: '#2E0205'}}>Importadores Directos</Card.Title>
                                <Card.Text className="text-muted">
                                    Somos importadores directos. Sin intermediarios, precios de bodega directamente para ti.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* Tarjeta 2 */}
                    <Col md={3} className="mb-4">
                        <Card className="color-bg-secundary h-100 p-4 border-0 shadow-sm">
                            <Card.Body className="text-center">
                                <div className="mb-3">
                                    <CheckCircleFill size={48} className="color-primary" />
                                </div>
                                <Card.Title className="fw-bold mb-3" style={{color: '#2E0205'}}>Calidad Premium</Card.Title>
                                <Card.Text className="text-muted">
                                    Materiales de primera calidad y acabados impecables en cada bolso.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* Tarjeta 3 */}
                    <Col md={3} className="mb-4">
                        <Card className="color-bg-secundary h-100 p-4 border-0 shadow-sm">
                            <Card.Body className="text-center">
                                <div className="mb-3">
                                    <PhoneFill size={48} className="color-primary" />
                                </div>
                                <Card.Title className="fw-bold mb-3" style={{color: '#2E0205'}}>Atención Personalizada</Card.Title>
                                <Card.Text className="text-muted">
                                    Te asesoramos para encontrar el bolso perfecto para ti.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* Tarjeta 4 */}
                    <Col md={3} className="mb-4">
                        <Card className="color-bg-secundary h-100 p-4 border-0 shadow-sm">
                            <Card.Body className="text-center">
                                <div className="mb-3">
                                    <AwardFill size={48} className="color-primary" />
                                </div>
                                <Card.Title className="fw-bold mb-3" style={{color: '#2E0205'}}>Garantía de Satisfacción</Card.Title>
                                <Card.Text className="text-muted">
                                    Tu satisfacción es nuestra prioridad. Compra con confianza.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            <PreguntasFrecuentes />
            <WhatsAppButton />
            <FooterPublic />
        </>
    );
};

export default AboutUs;
